import { CdkDrag, CdkDragHandle } from '@angular/cdk/drag-drop';
import { CdkScrollable } from '@angular/cdk/scrolling';
import { NgOptimizedImage } from '@angular/common';
import { Component, EventEmitter, OnDestroy, Output, inject, ChangeDetectionStrategy } from '@angular/core';
import { MatButton } from '@angular/material/button';
import { MatCard, MatCardActions, MatCardContent, MatCardHeader, MatCardSubtitle, MatCardTitle } from '@angular/material/card';
import { MatDialog, MatDialogActions, MatDialogClose, MatDialogContent, MatDialogRef, MatDialogTitle } from '@angular/material/dialog';
import { MatTab, MatTabGroup } from '@angular/material/tabs';
import { Subscription } from 'rxjs';
import { ShareObj } from '../../model/datatypes';
import { ExampleserviceService } from '../../provider/exampleservice.service';
import { FirebaseService } from '../../provider/firebase.service';
import { MediaService } from '../../provider/media.service';
import { AnalyticsService } from '../../provider/analytics.service';


@Component({
  selector: 'app-examples',
  templateUrl: './examples.component.html',
  styleUrls: ['./examples.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [NgOptimizedImage, MatDialogTitle, CdkDrag, CdkDragHandle, CdkScrollable, MatDialogContent, MatTabGroup, MatTab, MatCard, MatCardContent, MatCardHeader, MatCardTitle, MatCardSubtitle, MatCardActions, MatButton, MatDialogActions, MatDialogClose]
})
export class ExamplesComponent implements OnDestroy {
  fb = inject(FirebaseService);
  examples = inject(ExampleserviceService);
  private ms = inject(MediaService);
  private dialog = inject(MatDialog);
  dialogRef = inject<MatDialogRef<ExamplesComponent>>(MatDialogRef);
  analyticsService = inject(AnalyticsService);
  @Output() onLoadExample = new EventEmitter<any>();
  @Output() onLoadSharedFile = new EventEmitter<any>();
  @Output() onOpenFileManager = new EventEmitter<any>();
  local_examples: any;

  sharedFileSubscription!: Subscription;
  community_examples: Array<{ obj: ShareObj, img_src: string | null }> = [];
  placeholderImg: string = '/example_img/placeholder.png'

  constructor() {
    const examples = this.examples;

    this.local_examples = examples.getExamples();




  }

  async ngAfterViewInit() {

    this.sharedFileSubscription = this.fb.sharedFilesChangeEvent$.subscribe(files => {
      this.community_examples = files.public.slice().map(
        ex => ({
          obj: ex, img_src: null
        }));

      this.loadImages(this.community_examples);
      console.log("community_examples", this.community_examples);
    })

  }

  ngOnDestroy(): void {
    this.sharedFileSubscription.unsubscribe();
  }

  async loadImages(examples: Array<{ obj: ShareObj, img_src: string | null }>) {
    for (const example of examples) {
      if (example.obj.img !== "none") {
        example.img_src = await this.ms.loadImageViaURL(-1, example.obj.img);
      } else {
        example.img_src = this.placeholderImg;
      }
    }
  }

  openFileManager() {

    this.onOpenFileManager.emit();
  }

  loadExample(filename: string) {
    this.analyticsService.trackEvent('load_example', { name: filename });
    this.onLoadExample.emit(filename);
    this.dialogRef.close();
  }

  loadSharedFile(filename: string) {

    this.onLoadSharedFile.emit(filename);
    this.dialogRef.close();
  }

  openDocs(url: string) {
    let formatted_url = ""
    if (!url.startsWith("http://") && !url.startsWith("https://")) {
      formatted_url = "http://" + url;
    } else {
      formatted_url = url;
    }
    window.open(url)
  }



}

